export default __webpack_public_path__ + "static/media/virusorange-250-4-min.2d65b402.png";